import { CLAUDE_APP_PATHS } from "../lib/install-instructions";
import styles from "./GettingStarted.module.css";

interface Props {
  onHelp?: () => void;
}

export default function GettingStarted({ onHelp }: Props) {
  return (
    <div className={styles.banner}>
      <p className={styles.text}>
        The CAI marketplace is <strong>already installed</strong> in Claude Desktop. Just open
        <strong> {CLAUDE_APP_PATHS.organizationPlugins}</strong> and click the <strong>+</strong> icon to
        find plug-ins — no file downloads in Claude Desktop. Individual skills aren&rsquo;t listed
        in Organization Plugins, so download those from their detail page and add them manually. Claude
        Code installs from the same marketplace via CLI. See the setup guide for details.
      </p>
      {onHelp && (
        <button type="button" onClick={onHelp} className={styles.helpButton}>
          Setup guide
        </button>
      )}
    </div>
  );
}
